<template lang="html">
  <div id="about-us-2-page">

    <section class="info-1-section">
      <div class="container">
        <div class="box-intro">
          <h1 class="title">{{ $t("about_us.title1") }}</h1>

          <h4 class="sub">{{ $t("about_us.text1") }}</h4>
        </div>

        <div class="box-media">
          <img class="w-100" src="/public/images/pages/about/banner-1.jpg">
        </div>
      </div>
    </section>

    <section class="container info-2-section">
      <div class="row row-1">
        <div class="col-lg-12 pt-0 mt-1 box-1-info">
          <p class="p-lh"> {{ $t("about_us.text2") }}</p>


          <div class="row">
            <div class="col-lg-7 mt-5 mx-auto">
              <!-- <h3 class="mt-3">{{ $t("about_us.title2") }}</h3> -->
              <h3 class=" title-1">{{ $t("about_us.title4") }}</h3>
              <p class="mt-3 p-lh">
                {{ $t("about_us.text4") }}
              </p>
            </div>
          </div>

          <video class="mt-4" controls="" poster="public/videos/about-us-preview.jpg">
            <source src="public/videos/about-us.mp4" type="video/mp4">
          </video>

          <div class="box-f-section-3" style="margin-top: 50px;">
            <h3 class="title-1">{{ $t("about_us.title3") }}</h3>
            <p class="mt-2">
              {{ $t("about_us.text3") }}
            </p>

            <!-- <p class="text-center mt-5">
              <a class="btn btn-s1 blue btn-bg" target="_blank" href="https://www.google.com/maps/dir/WVJ3%2B6FW,+Carr.+John+F+Kennedy,+San+Jos%C3%A9,+Escaz%C3%BA/@9.930614,-84.2287003,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8fa0fc7d201f27f5:0xfc03190d124e0554!2m2!1d-84.1462984!2d9.9306241?entry=ttu">{{ $t("about_us.linkVisitUs") }}</a>
            </p> -->
          </div>
        </div>
      </div>
    </section>

    <section class="info-3-section">
      <div class="container">
        <div class="row row-images">
          
          <div class="col-md-6 col-image">
            <img src="/public/images/pages/about/image-1.jpg">
            <h6>Escazú</h6>
            <p>
              Plaza Los Laureles, Escazú, San José.
            </p>
          </div> 

          <div class="col-md-6 col-image">
            <img src="/public/images/pages/about/image-2.jpg">
            <h6>Nosara</h6>
            <p>
              Playa Guiones, Nosara, Guanacaste.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-connect">
            <h5>{{ $t("about_us.title5") }}</h5>
            <a @click="goToFooter()"> {{ $t("about_us.linkContact") }}</a>
          </div>

          <div class="col-lg-7 offset-lg-1 col-text">
            <h2>{{ $t("about_us.title6") }}</h2>
            <p>
              {{ $t("about_us.text5") }}
            </p>

            <p class="mt-4 pt-2">
              <router-link class="_link-s1 c-white" to="/agents">{{ $t("about_us.linkAgents") }}</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="container info-4-section">
      <div class="row row-2">
        <div class="col-lg-3 col-inf">
          <h6 v-html='$t("about_us.list1a")'></h6>
          <h2 class="ql-align-center">84</h2>
          <h5 class="ql-align-center">{{ $t("about_us.list1b") }}</h5>
        </div>

        <div class="col-lg-3 col-inf">
          <h6 v-html='$t("about_us.list2a")'></h6>
          <h2 class="ql-align-center">1,115</h2>
          <h5 class="ql-align-center">{{ $t("about_us.list2b") }}</h5>
        </div>

        <div class="col-lg-3 col-inf">
          <h6 v-html='$t("about_us.list3a")'></h6>
          <h2 class="ql-align-center">26,500</h2>
          <h5 class="ql-align-center">{{ $t("about_us.list3b") }}</h5>
        </div>

        <div class="col-lg-3 col-inf">
          <h6 v-html='$t("about_us.list4a")'></h6>
          <h2 class="ql-align-center">$143B</h2>
          <h5 class="ql-align-center">{{ $t("about_us.list4b") }}</h5>
        </div>
      </div>
    </section>

    <section class="container info-5-section">
      <div class="row row-2">
        <div class="col-lg-6 col-image">
          <img src="/public/images/pages/about/image-3.jpg">
        </div>

        <div class="col-lg-5 ml-lg-3 col-text">
          <h2>{{ $t("about_us.title7") }}</h2>
          <p>
            {{ $t("about_us.text6") }}
          </p>
        </div>
      </div>
    </section>

    <section class="container info-6-section">
      <div class="row">
        <div class="col-12 col-form">
          <h6 class="title" v-if="$i18n.locale == 'en'">Let’s get in touch</h6>
          <h6 class="title" v-if="$i18n.locale == 'es'">Mantengámonos en contacto</h6>
          <br>

          <b-form class="row justify-content-center" @submit="onSubmit">
            <div class="col-lg-5 mb-2">
              <b-form-group class="custom-f-group-2"
              :label='$t("contact.form.name")'>
                <b-form-input
                  v-model="form.name"
                  type="text"
                  size="lg"
                  placeholder=""
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-5 mb-2">
              <b-form-group class="custom-f-group-2"
              :label='$t("contact.form.lastname")'>
                <b-form-input
                  v-model="form.lastname"
                  type="text"
                  size="lg"
                  placeholder=""
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-5 mb-2">
              <b-form-group class="custom-f-group-2"
              :label='$t("contact.form.phone")'>
                <b-form-input
                  v-model="form.phone"
                  type="number"
                  size="lg"
                  placeholder=""
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-5 mb-2">
              <b-form-group class="custom-f-group-2"
              :label='$t("contact.form.email")'>
                <b-form-input
                  v-model="form.email"
                  type="email"
                  size="lg"
                  placeholder=""
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-10 mb-2">
              <b-form-group class="custom-f-group-2"
              :label='$t("contact.form.message")'>
                <b-form-textarea
                  v-model="form.comments"
                  placeholder=""
                  rows="4"
                  max-rows="4"
                  
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-5" style="background-color: black;"></div>

            <div class="col-12">
              <vue-recaptcha class="box-recaptcha"
                sitekey="6LcaE4okAAAAAFYKGFfWc9wbF0IXRcRBzSzZmiyw"
                ref="recaptcha"
                @verify="handleSuccess"
                >
              </vue-recaptcha>
            </div>

            <div class="col-12 mt-1 text-center">
              <b-button type="submit" class="btn-s1 blue btn-bg">{{$t("contact.form.submit")}}</b-button>
            </div>
          </b-form>

          <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
            <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
            <div v-html="modal.msg"></div>
          </sweet-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        comments: null,
        type:'Contáctenos About Sotheby’s Costa Rica',
        purpose:null,
      },

      recaptchaVerified:false,

      modal:{
        msg:'',
        icon:'',
        block:false,
      },
      row:{

      }
    }
  },

  methods: {
    goToSection(idx) {
      document.querySelector('#info-6-section').scrollIntoView({behavior: 'smooth'});
    },

    goToFooter(idx) {
      document.querySelector('#footer').scrollIntoView({behavior: 'smooth'});
    },

    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      if(this.recaptchaVerified == true){

        this.modal.block = true;
        this.modal.icon = "";
        this.modal.msg = "Loading...";
        this.$refs.modal.open();

        var params = this.form;
        var apiURL = tools.url("/api/contact");

        axios.post( apiURL,params )
        .then( (response) => {
          // alert(response.data.response);
          this.makeToast('success', response.data.response, 'Message sent');
          // alert(response.data.response);

          for (let prop in this.form) {
            this.form[prop] = '';
          }
          this.modal.block = false;
          //this.modal.icon = "success";
          //this.modal.msg = "Thank you for contacting us! We will get back to you as soon as possible.";
          this.$refs.modal.close();
          this.$router.push('/thankyou-page-aboutus');
        })
        .catch( (error) => {
          // console.log(error.response.data);
          let errors = error.response.data;

          for (let prop in errors) {
            // console.log(errors[prop]);
            this.makeToast('danger', errors[prop], '¡Error!');
          }
          this.modal.block = false;
          this.modal.icon = "error";
          this.modal.msg = "Error saving information";
        });
      }else{
        this.modal.block = false;
          this.modal.icon = "warning";
          this.modal.msg = "Complete the captcha";
          this.$refs.modal.open();
      }
    },

    handleSuccess(response) {
      this.recaptchaVerified = true;
    },
    getRow() { // Obtener la info de la BD

      axios.get("https://sircostarica.com/api/aboutus").then((response)=>{
      // axios.get(tools.url("/api/aboutus")).then((response)=>{
        this.row = response.data;

      });
    },
  },
  //insert the following code for vue-meta to work
  metaInfo() {
    return {
      meta: [
        { name: 'og:title', content: this.$root.seoadata.aboutus.meta_title},
        { name: 'og:description', content: this.$root.seoadata.aboutus.meta_description	},
        { name: 'og:keywords', content: this.$root.seoadata.aboutus.meta_keywords},
      ]
    }
  },
  mounted(){
      this.getRow();
  }
}
</script>
